import { AdvancedCobranding } from '../../utilities/cobranding/cobranding';

export type AdvancedCobrandedPage = {
  /**
   * Used for determining which experience to render. Make sure to add yours to the enum.
   * Corresponds to the right-hand side of the `application` URL search param value:
   *
   * ```
   * application=pollinator--demo
   *                         ^^^
   *                         This part of the value
   * ```
   */
  experience: AdvancedCobranding;
  /**
   * The component to render for your cobranded experience.
   *
   * Ensure you return an element within your component.
   * If you feel the need to return `null` for error cases, intermediate state, or while something is loading
   * Then return something for the user to see instead (loading indicator, an error page, etc)
   */
  Component: React.LazyExoticComponent<() => JSX.Element>;
  /**
   * @note THIS IS NOT CURRENTLY USED, SEE: src/pages/orchestrator/Orchestrator.tsx
   * A function that is called upon failure to load the Component
   */
  onFail?: () => Promise<void>;
  /**
   * The specific owner of the experiment/flow. Should be an Atlassian email address.
   */
  owner: string;
  /**
   * A Slack channel in the Atlassian Slack workspace for the owning team.
   */
  slackChannel: string;
  /**
   * Links to external testing/monitoring tools for the cobranded page. We recommend building a
   * pollinator and adding the link to this array in your config.
   *
   * See this doc for details:
   * https://hello.atlassian.net/wiki/x/JvkGAwE
   */
  monitoringUrls: string[];
};
